import { FC, useEffect, useState } from 'react'

import { Button } from 'core-components/library/button'

import { QbrAttachments } from '../../../steps/exportAndAttachments'
import { getJbpQbrAttachments } from '../../../steps/exportAndAttachments/components/qbrAttachments/helpers/getJbpQbrAttachments'

import styles from './QbrAttachmentsWrapper.module.scss'

interface IQbrAttachmentsWrapperProps {
  onSave?: () => void
}

export const QbrAttachmentsWrapper: FC<IQbrAttachmentsWrapperProps> = ({ onSave }) => {
  const [isSaveDisabled, setIsSaveDisabled] = useState(true)

  useEffect(() => {
    const crud = getJbpQbrAttachments()

    return crud.subscribe('change', () => {
      crud.fetch({ force: true }).then((response) => {
        setIsSaveDisabled(response.items.length === 0)
      })
    })
  }, [])

  return (
    <div className={styles.root}>
      <QbrAttachments />
      <div className={styles.actionControls}>
        <Button disabled={isSaveDisabled} onClick={onSave}>
          Save and close
        </Button>
      </div>
    </div>
  )
}
